module.exports = __webpack_public_path__ + "static/UnboundWorldsApart6-c583ab4efda3d5192350ddfabcdbb5c0.webp";